// extracted by mini-css-extract-plugin
module.exports = {"StaggeredImages":"StaggeredImages_StaggeredImages__OxxAN"};